module.exports = require("./objectWithoutProperties.js");


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/object-without-properties.js
// module id = 1097
// module chunks = 0